import React, {
  memo, useCallback, useMemo
} from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, IconButton } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';

import EquipmentFocusIcon from 'static/images/equipment-focus-inactive.svg';
import PathIconDisabled from 'static/images/route-path-disabled.svg';
import PathIconEnabled from 'static/images/route-path-enabled.svg';
import { actionCreators } from 'react/api/actions/monitor';

function ActionButtons({ routeView }) {
  const { primaryEquipment, route } = routeView;
  const dispatch = useDispatch();

  const routeIsOnTheMap = useSelector(
    (state) => state.routeMonitor.routesOnMap.find((item) => item.id === route.id)
  );
  const equipmentFocusTitle = getResourceTo('RouteMonitor.filter.equipmentFocus');
  const pathFocusTitle = getResourceTo('RouteMonitor.filter.pathFocus');

  const hasIconPathDisabled = useMemo(() => {
    if (Monet.Session.Maps) {
      const { markers } = Monet.Session.Maps.mainMap;
      if (markers && primaryEquipment && markers[primaryEquipment.id]) {
        return false;
      }
    }
    return true;
  }, []);

  const goToTruckHandler = useCallback(() => {
    const view = new Greenmile.RouteMonitor.Routes();
    view.goToTruck(routeView, hasIconPathDisabled);
  }, [hasIconPathDisabled]);

  const handleAddRouteToMap = useCallback(() => {
    if (!routeIsOnTheMap) {
      dispatch(actionCreators.addRouteToMap({
        id: route.id
      }));
    } else {
      dispatch(actionCreators.removeRouteFromMap({
        id: route.id
      }));
    }
  }, [routeIsOnTheMap]);

  return (
    <Flex gap={4} dataTestId={`${route.key}-map-buttons`}>
      <IconButton
        size="sm"
        dataTestId={`${route.key}-focus-path`}
        title={pathFocusTitle}
        variant="secondary"
        onClick={handleAddRouteToMap}
      >
        <img src={routeIsOnTheMap ? PathIconEnabled : PathIconDisabled} alt="Path Focus Icon" />
      </IconButton>
      <IconButton
        disabled={hasIconPathDisabled}
        title={equipmentFocusTitle}
        dataTestId={`${route.key}-focus-truck`}
        onClick={goToTruckHandler}
        size="sm"
        variant="secondary"
      >
        <img src={EquipmentFocusIcon} alt="Equipment Focus Icon" />
      </IconButton>
    </Flex>
  );
}

ActionButtons.propTypes = {
  routeView: PropTypes.object.isRequired
};

export default memo(ActionButtons);
